import React from "react";
import '../../App.css';
import Footer from "../Footer";
import { useEffect } from 'react';

export default function Programme() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="programme-container">
                <h1 className="page-title">Page Not Found!</h1>
            </div>
            <Footer />
        </>
    )
}